export const MISSING_DOCUMENT_ACCEPTED = "MISSING_DOCUMENT_ACCEPTED";
export const MISSING_DOCUMENT_SNOOZED = "MISSING_DOCUMENT_SNOOZED";
export const MISSING_DOCUMENT_UPDATED = "MISSING_DOCUMENT_UPDATED";
export const MISSING_DOCUMENT_UPDATED_CONTENT = "MISSING_DOCUMENT_UPDATED_CONTENT";
